var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin-site-audit-log" }, [
    _c(
      "div",
      { staticClass: "admin-site-audit-log__panel" },
      [
        _c("div", { staticClass: "admin-site-audit-log__panel-head" }, [
          _c(
            "i",
            { staticClass: "material-icons admin-site-audit-log__head-icon" },
            [_vm._v("history")]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "admin-site-audit-log__head-title" }, [
            _vm._v(_vm._s(_vm.$t("auto.adminSiteAuditLog"))),
          ]),
        ]),
        _vm._v(" "),
        _c("NewSupsisTable", {
          staticClass: "admin-site-audit-log__table",
          attrs: {
            columns: _vm.tableColumns,
            data: _vm.rows,
            loading: _vm.loading,
            zebra: true,
            "show-column-add": false,
            "sortable-columns": false,
            resizable: true,
            "min-column-width": 88,
            "row-key": "_id",
          },
          scopedSlots: _vm._u([
            {
              key: "cell-createdAt",
              fn: function (slotProps) {
                return [
                  _c("div", { staticClass: "cell-datetime" }, [
                    _c("span", { staticClass: "cell-datetime__date" }, [
                      _vm._v(_vm._s(_vm.formatDate(slotProps.row.createdAt))),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "cell-datetime__time" }, [
                      _vm._v(_vm._s(_vm.formatTime(slotProps.row.createdAt))),
                    ]),
                  ]),
                ]
              },
            },
            {
              key: "cell-summary",
              fn: function (slotProps) {
                return [
                  _c(
                    "a-tag",
                    {
                      staticClass: "cell-summary-tag",
                      attrs: { color: _vm.summaryTagColor(slotProps.row) },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.eventSummary(slotProps.row)) +
                          "\n                "
                      ),
                    ]
                  ),
                ]
              },
            },
            {
              key: "cell-description",
              fn: function (slotProps) {
                return [
                  _c("p", { staticClass: "cell-description" }, [
                    _vm._v(_vm._s(_vm.descriptionText(slotProps.row))),
                  ]),
                ]
              },
            },
            {
              key: "cell-actor",
              fn: function (slotProps) {
                return [
                  _c("span", { staticClass: "cell-actor" }, [
                    _vm._v(_vm._s(_vm.actorLabel(slotProps.row))),
                  ]),
                ]
              },
            },
            {
              key: "empty",
              fn: function () {
                return [
                  _c("span", { staticClass: "cell-empty" }, [
                    _vm._v(_vm._s(_vm.$t("auditLogs.noActivityYet"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
        _vm._v(" "),
        _vm.totalCount > 0
          ? _c(
              "div",
              { staticClass: "admin-site-audit-log__pager" },
              [
                _c("a-pagination", {
                  attrs: {
                    current: _vm.cursor.page,
                    "page-size": _vm.cursor.perPage,
                    total: _vm.totalCount,
                    "show-size-changer": true,
                    "page-size-options": ["10", "20", "50", "100"],
                  },
                  on: {
                    change: _vm.onPageChange,
                    showSizeChange: _vm.onSizeChange,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }